import Vue from "vue";
import * as MUTATIONS from "../config/constants/mutation-types";

export default {
  /**
   * Mutation llamada por el router
   * Ponemos la ruta en el state
   * @param {Object} state
   * @param {Object} payload
   */
  [MUTATIONS.ON_ROUTE]: (state, payload) => {
    Vue.set(state, "route", payload);
  },

  /**
   * Mutation llamada por el router
   * Ponemos la ruta en el state
   * @param {Object} state
   * @param {String} tcode
   */
  [MUTATIONS.ON_TCODE]: (state, tcode) => {
    Vue.set(state, "tcode", tcode);
  },

  [MUTATIONS.ON_TIPO_ERROR]: (state, payload) => {
    Vue.set(state, "tipoError", payload);
  },
  /**
   * Mostrar u ocultar el loader
   * @param {Object} context
   * @param {Boolean} payload estado
   */
  [MUTATIONS.ON_IS_LOADING]: (state, payload) => {
    Vue.set(state, "isLoading", !!payload);
  },
  [MUTATIONS.ON_NOTIFICATION_TOAST]: (state, payload) => {
    Vue.set(state, "notificationToast", payload);
  },
  /**
   * Mutation disparadas por el
   * step navigator para avanzar pasos
   * Cada action guarda el paso
   * actual en el store
   * @param {Object} state
   */
  [MUTATIONS.ON_LANDING]: (state, payload) => {
    Vue.set(state, "landing", payload);
  },
  [MUTATIONS.ON_PASO_1]: (state, payload) => {
    Vue.set(state, "paso1", payload);
  },
  [MUTATIONS.ON_PASO_2]: (state, payload) => {
    Vue.set(state, "paso2", payload);
  },
  [MUTATIONS.ON_PASO_3]: (state, payload) => {
    Vue.set(state, "paso3", payload.respuesta);
    if (payload.respuesta.premios.length == 1) {
      Vue.set(
        state.paso3,
        "seleccion",
        payload.respuesta.premios[0].codigoPremio
      );
    }
  },
  [MUTATIONS.ON_PASO_4]: (state, payload) => {
    Vue.set(state.paso4, "url", payload.respuesta.uri);
  },
  [MUTATIONS.ON_URL]: (state, payload) => {
    Vue.set(state.paso4, "hash", payload.respuesta.message);
  },
  [MUTATIONS.ON_CAMPANIA]: (state, payload) => {
    Vue.set(state, "tipoCampaniaSeleccionada", payload);
  },
  [MUTATIONS.ON_GRACIAS]: (state, payload) => {
    Vue.set(state, "gracias", payload);
  },
  [MUTATIONS.ADOBE_INTERNAL_LINK]: () => {},
  [MUTATIONS.ADOBE_APP_STARTED]: (state, payload) => {
    Vue.set(state, "trackClickElement", payload);
  },
  [MUTATIONS.ON_USER_ID_TOKENIZADO]: (state, payload) => {
    Vue.set(state, "userIdTokenizado", payload);
  }
};
